export default "__VITE_PUBLIC_ASSET__080b0601__"